









































import { Component, Prop, Vue } from "vue-property-decorator";
import { Total as TotalModel } from "@/types/total";
import { RefuelingHistoryEntry } from "@/types/refuelingEvent";

@Component
export default class Total extends Vue {
    name = "Total";

    @Prop() refuelings!: RefuelingHistoryEntry[];

    get costs(): number {
        return this.refuelings.reduce((sum, obj) => sum + (obj.pricePerLiter * obj.liters), 0);
    }

    get liters(): number {
        return this.refuelings.reduce((sum, obj) => sum + obj.liters, 0);
    }

    get kilometers(): number {
        return this.getKilometers();
    }

    get count(): number {
      return this.refuelings.length;
    }

    private getKilometers(): number {
        if (!this.refuelings || this.refuelings.length === 0)
            return 0;
        if (this.refuelings.length === 1)
            return 800;
        return this.refuelings[0].mileage - this.refuelings[this.refuelings.length-1].mileage;
    }
}
